import { render, staticRenderFns } from "./ChangeLeverage.vue?vue&type=template&id=54ab9950"
import script from "./ChangeLeverage.vue?vue&type=script&lang=js"
export * from "./ChangeLeverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports